module.exports = __webpack_public_path__ + "static/img/bg_bottom.84f8c6d5.png";